
export class ChangePasswordDialogController {

    public static $inject: string[] = [
        '$mdDialog',
        'gettextCatalog',
        'pxAuthService'
    ];

    public password: string = '';
    public newPassword: string = '';
    public confirmPassword: string = '';
    public changePasswordForm: ng.IFormController;

    public errorMessage: string = '';

    public get disableSaveButton(): boolean {
        return !this.changePasswordForm || this.changePasswordForm.$invalid;
    }

    constructor(private readonly $mdDialog: any, private readonly gettextCatalog: any, private readonly pxAuthService: any) {
    }

    public changePassword(): void {
        if (this.newPassword !== this.confirmPassword) {
            this.errorMessage = this.gettextCatalog.getString('New Password and Confirm Password do not match.');
            return;
        }

        this.pxAuthService.changePassword(this.password, this.newPassword, this.confirmPassword)
            .then(res => {
                if (res.data) {
                    if (res.data.AuthenticationFailed) {
                        this.errorMessage = this.gettextCatalog.getString('The old password you entered is incorrect');
                    } else {
                        this.errorMessage = res.data.Error;
                    }
                } else {
                    this.$mdDialog.hide(res);
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/sharebase/components/myAccount/changePasswordDialog/changePasswordDialog.component.ts